var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLeftThick16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.261 8c0-.468.2-.869.535-1.136L11.283.313c.534-.468 1.27-.401 1.738.134.4.534.4 1.27-.134 1.67l-6.55 5.75c-.068.066-.068.133 0 .2l6.55 5.748c.535.468.601 1.204.133 1.738-.467.535-1.203.602-1.737.134l-.067-.067-7.42-6.484C3.462 8.87 3.261 8.401 3.261 8z"
  })));
}
export default SvgIconLeftThick16;